import { render } from "./AppTile.vue?vue&type=template&id=489a83fd&scoped=true"
import script from "./AppTile.vue?vue&type=script&lang=js"
export * from "./AppTile.vue?vue&type=script&lang=js"

import "./AppTile.vue?vue&type=style&index=0&id=489a83fd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489a83fd"]])

export default __exports__